import type { ChatMessage } from "@/zapi-frontend/stores/chatStore";

export const isVaultItemsMessage = (message: ChatMessage | undefined) => {
  try {
    return message?.role === "user" && JSON.parse(message.content)?.type === "vault_items";
  } catch {
    return false;
  }
};

// A reload in the middle of a reply leaves its empty bubble behind, so the restored chat drops it.
export const dropUnfinishedReply = (messages: ChatMessage[]): ChatMessage[] => {
  const last = messages[messages.length - 1];
  if (last?.role !== "assistant") return messages;
  try {
    const parsed = JSON.parse(last.content);
    if (parsed?.type !== "answer" || parsed.templateKey || parsed.content) return messages;
  } catch {
    return messages;
  }
  return messages.slice(0, -1);
};

// Leaving while Leo read the saved files cut the read off: the chat ends on the files message, still
// on the decision step, and the read is started again rather than sending the setup back to Save.
export const isInterruptedFilesRead = (messages: ChatMessage[], step: string) =>
  step === "decision" && isVaultItemsMessage(messages[messages.length - 1]);
